module.exports = __webpack_public_path__ + "static/media/sound3.79b749a6.mp3";